import(/* webpackMode: "eager", webpackExports: ["default"] */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn","Stagger","FadeInStaggerItem"] */ "/workspace/components/ui/motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/TiltCard.tsx");
